<template>
  <v-card>
    <v-card-title>
      Role
    </v-card-title>
    <v-card-actions>
      <v-btn small color="primary" exact to="/app/roles/create">Vytvořit roli</v-btn>
      <v-btn small :disabled="selectedRole.length === 0"
             outlined color="primary"
             exact @click="deleteRole()">Smazat roli
      </v-btn>
      <v-btn small color="primary" outlined @click="exportCsv">Export CSV</v-btn>
    </v-card-actions>
    <v-card-text>
      <data-search
          @search="getData"
          @input="search = $event"/>
    </v-card-text>
    <v-data-table class="yzz-table"
                  dense
                  :headers="headers"
                  :items="items"
                  :server-items-length="itemsLength"
                  :options.sync="options"
                  :footer-props="footerProps"
                  multi-sort
                  show-select
                  single-select
                  mobile-breakpoint="-1"
                  v-model="selectedRole"
                  @click:row="openRole"
    >
      <template #item.createdAt="{ item }">
        {{ formatCreatedAt(item) }}
      </template>
      <template #item.updatedAt="{ item }">
        {{ formatUpdatedAt(item) }}
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import {formatDatetime} from '@/helper/date-helper'
import {exportCSVFile, generateRequestParams} from '@/helper/global-helper'

export default {
  name: "RolesTable",
  data() {
    return {
      headers: [
        {text: 'ID', value: 'id'},
        {text: 'Název', value: 'name'},
        {text: 'Popis', value: 'description'},
        {text: 'Vytvořeno', value: 'createdAt'},
        {text: 'Upraveno', value: 'updatedAt'},
      ],
      options: {
        itemsPerPage: 15
      },
      footerProps: {
        itemsPerPageOptions: [15, 25, 50, 100, 250, 500, 1000]
      },
      data: null,
      search: null,
      selectedRole: []
    }
  },
  mounted() {
    this.getData()
  },
  computed: {
    itemsLength() {
      if (!this.data) return 0
      return this.data.totalElements
    },
    items() {
      if (!this.data) return []
      return this.data.content
    }
  },
  methods: {
    getData() {
      this.axios.get('/api/admin/role', {
        params: generateRequestParams(
            this.options.page,
            this.options.itemsPerPage,
            this.search,
            this.options.sortBy,
            this.options.sortDesc
        )
      })
          .then(({data}) => {
            this.data = data
          })
    },
    openRole({id}) {
      this.$router.push('/app/roles/' + id)
    },
    formatCreatedAt({createdAt}) {
      return formatDatetime(createdAt)
    },
    formatUpdatedAt({updatedAt}) {
      return formatDatetime(updatedAt)
    },
    deleteRole() {
      const role = this.selectedRole[0].id
      this.axios.delete('/api/admin/role/' + role)
          .then(({data}) => {
            this.selectedRole = []
            if (this.data)
              this.data.content = this.data.content.filter(item => item.id !== role)
          })
    },
    exportCsv(){
      exportCSVFile(this.headers, this.items, 'roles')
    }
  },
  watch: {
    options: {
      handler() {
        this.getData()
      },
      deep: true,
    }
  }
}
</script>